export const Header = () => (
  <div className="mb-6">
    <h2 className="text-xl font-bold text-slate-800">Create Customer</h2>
    <p className="text-sm text-slate-500">
      Complete all steps to onboard a customer
    </p>
  </div>
);